import styled from 'styled-components';
import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {red} from "../styles";

const Page = styled.main`
  text-align: left;
  color: #3c3b3b;
`;
const Loading = styled.div`
  margin: 30px auto;
  font-size: 40px;
  text-align: center;
  color: ${red}
`;
const Office = styled.div`
  font-weight: bold;
  font-style: italic;
  font-size: 14px;
  line-height: 1.7;
`;
const Candidate = styled.div`
`;

function Admin() {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [ballot, setBallot] = useState(null);
    const navigate = useNavigate();
    const {
        pathname
    } = useLocation();

    const exportCsv = async e => {
        e.preventDefault();

        setIsLoading(true);
        await fetch(`/api/listVotes`, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        setIsLoading(false);
    };

    useEffect(() => {(async () => {
        try {
            const result = await fetch(`/api/voteSummary`, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if ( result.status === 401 ) {
                navigate('/login?redirect=' + encodeURIComponent(pathname));
            } else if ( result.status === 403 ) {
                setError("You do not have access to this page");
            } else if ( result.status === 200 ) {
                const { ballot } = await result.json();
                setError(null);
                setBallot( ballot );
            } else {
                setError("An unexpected error occurred");
            }
        } catch (e) {
            setError("An unexpected error occurred");
        }
        setIsLoading(false);
    })()}, []);

    if ( isLoading ) {
        return (
            <Page>
                <Loading>
                    <FontAwesomeIcon icon={faSpinner} className="fa-spin"/>
                </Loading>
            </Page>
        );
    } else if ( error ) {
        return (
            <span className="row">
                <span className="alert alert-danger" role="alert">
                    {error}
                </span>
                <br/>
            </span>
        );
    }

    return (
        <Page>
            <Link to="/ballot-preview/23-24">Preview: {ballot.title}</Link>
            <br/>
            <br/>
            <a href="/api/listVotes" target="_blank">{ballot.title} Voter Export</a>
            <br/>
            <br/>
            {ballot.offices.map(office => (
                <div key={office.id}>
                    <Office>{office.name}</Office>
                    {office.candidates.map(candidate => (
                        <React.Fragment key={candidate.id}>
                            <Candidate>{candidate.name}, {candidate.titles} ({candidate.votes || 0})</Candidate>
                        </React.Fragment>
                    ))}
                    <Candidate>Write In ({office.writeIns ? office.writeIns.length : 0})</Candidate>
                    <br/>
                    {
                        office.writeIns && office.writeIns.length ? (
                            <React.Fragment>
                                <Candidate>Write Ins:</Candidate>
                                {office.writeIns.map(writeIn => (
                                  <React.Fragment key={writeIn}>
                                    <Candidate>{writeIn}</Candidate>
                                  </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : null
                    }
                    <br/>
                </div>
            ))}
            <br/>
            <br/>
        </Page>
    );
}

export default Admin;
